exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbarCategories {\n  background-color: #F7F7F7;\n  height: 6.6rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  z-index: 150;\n  text-align: center;\n  padding: 0 2rem 0 2rem;\n  position: relative;\n  width: 100%;\n}\n.navbarCategories p {\n  text-align: center;\n  position: absolute;\n  right: 50%;\n  -webkit-transform: translateX(50%);\n          transform: translateX(50%);\n  width: 70%;\n}\n.navbarCategories img {\n  height: 2.4rem;\n  width: 2.4rem;\n}", ""]);

// exports
